const financialBill = [
  {
    path: '/financial/bills',
    name: 'Bills',
    meta: {
      auth: true,
      roles: ['Director', 'SalesExecutive', 'Manager', 'Analyst', 'Financial', 'Logistics', 'Seller', 'CreditAnalyst'],
    },
    component: () => import('@/_backoffice/_financial/components/bill/Bills.vue'),
  },
]

export default financialBill
